import Renderer from "@wielink/datatables/Renderers/Renderer";

class Connect extends Renderer {
	render() {
		return `
			<button data-dt-btn="disconnect" data-id="${this.row.id}" class="btn btn-sm btn-danger" aria-label="Ontkoppelen" title="Ontkoppelen">
				<i class="bi bi-x-lg"></i>
			</button>
		`
	}
}

export default Connect;